import { useEffect } from "react";
import { http, API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useRealtimeTick } from "@/lib/realtime";
import { applyTheme } from "@/lib/theme";

export function ThemeSync() {
  const { user } = useAuth();
  const tick = useRealtimeTick((m) => m.path.startsWith("/api/theme"));
  useEffect(() => {
    if (user) http.get("/theme").then((r) => applyTheme(r.data.effective)).catch(() => {});
    else fetch(`${API}/public/login`).then((r) => r.json()).then((d) => applyTheme(d.theme)).catch(() => {});
  }, [user, tick]);
  return null;
}
